import { createStore, combineReducers } from "redux";
import localReducer from "./localReducer";

const rootReducer = combineReducers({
  local: localReducer,
});

export const store = createStore(
  rootReducer,
);
